import { Text } from '@mantine/core';
import { IconBook } from '@tabler/icons-react';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';

export function AIKnowledgeRetrievalCard({
  message,
}: {
  message: Extract<AIMessage, { type: 'knowledge-retrieval' }>;
}) {
  return (
    <CollapsibleCard
      icon={IconBook}
      title="Knowledge Retrieved"
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div className="mx-1 rounded">
        <Text
          size="xs"
          className="mb-1 font-medium"
        >
          Found: {message.knowledgeItems.length} items
        </Text>
        {message.knowledgeItems.length > 0 ?
          <div className="space-y-2">
            {message.knowledgeItems.map((item, index) => (
              <div
                key={index}
                className="rounded border border-gray-200 bg-gray-50 p-3 dark:border-gray-600 dark:bg-gray-800"
              >
                <Text
                  size="sm"
                  className="italic leading-relaxed"
                >
                  &quot;{item}&quot;
                </Text>
              </div>
            ))}
          </div>
        : <Text
            size="sm"
            className="italic"
          >
            No relevant knowledge found
          </Text>
        }
      </div>
    </CollapsibleCard>
  );
}
